module.exports = __webpack_public_path__ + "static/img/img_cat_32.13cbe34.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_32.png
// module id = 539
// module chunks = 1